import { Provider } from '@angular/core';

import { FederationsService } from '@federations/services/federations.service';
import { FEDERATION_STORE } from '@federations/stores/federation.store';

export const FEDERATION_PROVIDERS: Provider[] = [
  FederationsService,
  FEDERATION_STORE
];
